export default __webpack_public_path__ + "static/media/icon_skill_fist_3.e3b1e9aa.png";